import React, { ElementType, ReactElement } from "react";
import classNames from "classnames";
import RichTextProps from "./types";
import { capitalizeFirstLetter } from "@ramsey-design-system/common";

const RichText = <C extends ElementType = "div">({
  children,
  className,
  element,
  isOnDarkCanvas = false,
  lineHeight = "large",
  size = "medium",
  ...rest
}: RichTextProps<C>): ReactElement => {
  const capitalizedLineHeight = capitalizeFirstLetter(lineHeight);

  const richTextClassNames = classNames(
    "rds-RichText",
    {
      [`rds-RichText--lineHeight${capitalizedLineHeight}`]:
        lineHeight !== "large",
      [`rds-RichText--${size}`]: size !== "medium",
      "on-darkCanvas": isOnDarkCanvas,
    },
    className
  );

  const Element = element || "div";

  return (
    <Element className={richTextClassNames} {...rest}>
      {children}
    </Element>
  );
};

RichText.displayName = "RichText";

export default RichText;
